export default __webpack_public_path__ + "static/media/co.b6414e08.svg";